import { useContext, useEffect, useRef, useState } from "react";
import SetHumidity from "../../constants/SetHumidity";
import HumidityChanges from "../../constants/HumidityChange";
import { Context } from "../../context/Context";
import { ShareBackup } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";

const ShareBackupModal = ({ setShareBackupModal, backupId }) => {
  const { setIsLoading } = useContext(Context);

  const [phoneNumber, setPhoneNumber] = useState("");

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setShareBackupModal(modalName);
  }, []);

  const handleChangePhoneNumber = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleSubmit = () => {
    setIsLoading(true);
    
    // بررسی و فرمت‌دهی ورودی کاربر
    let formattedPartner = phoneNumber.trim();
    
    // اگر ورودی با صفر شروع می‌شود و فقط شامل اعداد است، صفر اول را حذف می‌کنیم
    // و اگر شامل @ باشد، آن را به عنوان ایمیل در نظر می‌گیریم و بدون تغییر می‌فرستیم
    if (formattedPartner.startsWith('0') && /^\d+$/.test(formattedPartner)) {
      // شماره موبایل: حذف صفر اول
      formattedPartner = formattedPartner.substring(1);
    }
    // اگر شامل @ باشد، ایمیل است و بدون تغییر می‌ماند
    // در غیر این صورت اگر با 0 شروع نشده باشد، همانطور که هست می‌فرستیم
    
    ShareBackup({
      backup_id: backupId,
      partner: formattedPartner,
    })
      .then(({ data }) => {
        if (!data.error) {
          SuccessToast(data.message);
          closeButton.current.click();
          setIsLoading(false);
        } else {
          ErrorToast(data.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        ErrorToast("کاربری با این مشخصات یافت نشد");
        setIsLoading(false);
      });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              اشتراک با مخاطب دیگر
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <div>
                <label htmlFor="defaultFormControlInput" className="form-label">
                  شماره همراه یا ایمیل مخاطب را وارد کنید
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="مثال: 9123456789 یا example@email.com"
                  value={phoneNumber}
                  onChange={(e) => handleChangePhoneNumber(e)}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmit}
            >
              ثبت
            </button>
            {/* <button
              type="button"
              className="btn btn-secondary me-3 mb-2"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            >
              انصراف
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareBackupModal;